<script setup lang="ts">
const tuvnordLogoSrc: string = "/images/logos/tuvnord-logo-2023.jpeg";
</script>
<template>
    <img :src="tuvnordLogoSrc" alt="Logo Tüv Nord Argentina" />
</template>
